import { render } from "./AdminSelector.vue?vue&type=template&id=4e58fec4&scoped=true"
import script from "./AdminSelector.vue?vue&type=script&lang=js"
export * from "./AdminSelector.vue?vue&type=script&lang=js"

import "./AdminSelector.vue?vue&type=style&index=0&id=4e58fec4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e58fec4"]])

export default __exports__